import $ from 'jquery';


let search = {

  $input : $('.searchbar__head input'),
  keyword: '',

  init(){
    this.clickSearch();
    // this.initSearch();
  },


  clickSearch(){
    $('.header .sidebar-right a').click((e) => {
      e.preventDefault();
      $('.header').find('.searchbar').addClass('open');
    })
    $('.header #close-search').click((e) => {
      e.preventDefault();
      $('.header').find('.searchbar').removeClass('open');
    })
  },

  initSearch(){
    this.$input.keyup(this.debounce( (e) =>{
      e.preventDefault();
      this.keyword = this.$input.val();
      this.fetchResults();
    }, 500));
  },

  fetchResults(){
    if( this.keyword.length > 2 ){
      $('.searchbar__main__wrapper').html(this.keyword);
      $('.searchbar__main').addClass('open');
    }
    else{
      $('.searchbar__main').removeClass('open');
    }
  },

  debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    }
  }

}
export default search;